import { useEffect, useState } from 'react';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    // Guard for environments where `window` is not available (e.g., SSR)
    if (typeof window === 'undefined') return;

    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    // Cleanup the listener on unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 滚动到联系区域
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // 滚动到专业服务区域
  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // 滚动互动效果计算
  const scrollProgress = Math.min(scrollY / 800, 1);
  const heroOpacity = Math.max(0.2, 1 - scrollProgress * 0.8);
  const heroScale = Math.max(0.9, 1 - scrollProgress * 0.1);
  const contentTranslateY = scrollProgress * 50;
  const overlayOpacity = Math.min(0.7, 0.4 + scrollProgress * 0.3);

  return (
    <section 
      className="relative min-h-screen flex items-center justify-start overflow-hidden z-10"
      style={{
        opacity: heroOpacity,
        transform: `scale(${heroScale})`,
        transition: 'opacity 0.1s ease-out, transform 0.1s ease-out'
      }}
    >
      {/* 视频背景 */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover z-0"
      >
        <source src="https://public.readdy.ai/ai/video_res/8fe2141e-d8d1-418c-83b9-f8aaefc0e2c6.mp4" type="video/mp4" />
      </video>

      {/* 动态深色遮罩 */}
      <div
        className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/40 to-black/60 z-10"
        style={{
          opacity: overlayOpacity,
          transition: 'opacity 0.1s ease-out',
        }}
      ></div>

      <div className="relative z-20 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className="max-w-2xl"
          style={{
            transform: `translateY(${contentTranslateY}px)`,
            transition: 'transform 0.1s ease-out',
          }}
        >
          <div className="space-y-8">
            <div className="space-y-6">
              <h1
                className="text-5xl lg:text-6xl xl:text-7xl font-light text-white leading-tight"
                style={{
                  transform: `translateY(${contentTranslateY * 0.5}px)`,
                  transition: 'transform 0.1s ease-out',
                }}
              >
                Strategic Consulting for{' '}
                <span className="font-normal">Growth</span>
              </h1>

              <p
                className="text-xl lg:text-2xl text-white/90 leading-relaxed font-light max-w-xl"
                style={{
                  transform: `translateY(${contentTranslateY * 0.3}px)`,
                  transition: 'transform 0.1s ease-out',
                }}
              >
                Data-driven solutions to elevate your business with measurable
                results.
              </p>
            </div>

            <div
              className="flex flex-col sm:flex-row gap-6"
              style={{
                transform: `translateY(${contentTranslateY * 0.2}px)`,
                opacity: Math.max(0.3, 1 - scrollProgress * 0.7),
                transition:
                  'transform 0.1s ease-out, opacity 0.1s ease-out',
              }}
            >
              <button 
                onClick={scrollToContact}
                className="bg-white text-gray-900 px-10 py-5 text-lg font-medium hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer rounded-full"
              >
                Book a Consult
              </button>
              <button 
                onClick={scrollToServices}
                className="px-10 py-5 text-lg font-light text-white border-2 border-white/50 hover:border-white hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer rounded-full"
              >
                Learn More
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* 滚动指示器 */}
      <div
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20"
        style={{
          opacity: Math.max(0, 1 - scrollProgress * 2),
          transition: 'opacity 0.2s ease-out',
        }}
      >
        <div className="flex flex-col items-center space-y-2">
          <span className="text-white/70 text-sm font-light">
            Scroll to explore
          </span>
          <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
            <div className="w-1 h-3 bg-white/50 rounded-full mt-2 animate-bounce"></div>
          </div>
        </div>
      </div>
    </section>
  );
}